import React, { FunctionComponent, MouseEventHandler } from "react";
import { CheckBox, CheckBoxOutlineBlank, IndeterminateCheckBox, RadioButtonChecked, RadioButtonUnchecked } from "@mui/icons-material";
import classNames from "classnames";

import "../../../../css/filter_bar/menu_item_selection_icon.css";

export type Props = {
  checked?: boolean
  dataValue: string
  indeterminate?: boolean
  multiSelect?: boolean
  onClick: MouseEventHandler
}

const MenuItemSelectionIcon: FunctionComponent<Props> = function MenuItemSelectionIcon(props) {
  const iconProps = {
    className: classNames("MenuItemSelectionIcon", {
      "MenuItemSelectionIcon-checked": props.checked,
      "MenuItemSelectionIcon-indeterminate": props.indeterminate
    }),
    "data-value": props.dataValue,
    "aria-checked": props.checked,
    "aria-hidden": false,
    "focusable": true,
    onClick: props.onClick
  };

  if (props.multiSelect) {
    if (props.checked) {
      if (props.indeterminate) {
        return <IndeterminateCheckBox role="checkbox" {...iconProps}/>;
      } else {
        return <CheckBox role="checkbox" {...iconProps}/>;
      }
    } else {
      return <CheckBoxOutlineBlank role="checkbox" {...iconProps}/>;
    }
  } else {
    if (props.checked) {
      return <RadioButtonChecked role="radio" {...iconProps}/>;
    } else {
      return <RadioButtonUnchecked role="radio" {...iconProps}/>;
    }
  }
};

MenuItemSelectionIcon.defaultProps = {
  checked: false,
  indeterminate: false,
  multiSelect: false
};

export default React.memo(MenuItemSelectionIcon);
